import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { fetch, handleErrors } from '../../api';
import api from '../../api/endpoints';

function* getAnalyticsCampaignModifiers({ payload: { signal, searchQ, curr_page } }) {
  try {
    const { data } = yield call(fetch, { api: api.analytics.campaign_modifiers, params: { page: curr_page, q: searchQ }, signal });
    yield put(actions.getAnalyticsCampaignModifiersDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getAnalyticsCampaignModifiersFailed,
      endpoint: api.analytics.campaign_modifiers.url
    });
  }
}

export const getAnalyticsCampaignModifiersSaga = takeEvery(types.GET_ANALYTICS_CAMPAIGN_MODIFIERS_REQUEST, getAnalyticsCampaignModifiers);


